import { WorkerRequirementStatus } from "@clipboard-health/contract-worker-app-bff";
import { type DocumentStatusPillVariant } from "@src/appV2/redesign/Documents/components/StatusPill";

export const DOCUMENT_BEHAVIOR_TYPES = {
  VISIBLE: "visible",
  INVISIBLE: "invisible",
} as const;

export type DocumentBehaviorType =
  (typeof DOCUMENT_BEHAVIOR_TYPES)[keyof typeof DOCUMENT_BEHAVIOR_TYPES];

export const WORKER_REQUIREMENT_STATUS_TO_PILL_MAP: Record<
  WorkerRequirementStatus,
  DocumentStatusPillVariant | undefined
> = {
  [WorkerRequirementStatus.REJECTED]: "rejected",
  [WorkerRequirementStatus.EXPIRED]: "expired",
  [WorkerRequirementStatus.EXPIRING]: "expiring_soon",
  [WorkerRequirementStatus.IN_REVIEW]: "in_review",
  [WorkerRequirementStatus.APPROVED]: undefined,
  [WorkerRequirementStatus.MISSING]: undefined,
};
